import React from "react";

import Tooltip from "@shared/v2/Tooltip";
import { CircleInfoSolidV6 } from "@shared/v2/Icomoon";

const ResultsCount = ({ resultCount, totalAvailable, className, maxRequested = 100 }) => {
  // This is looking at the total instead of returned because we frequently will have some amount less than the requested due to downstream filtering
  const areMoreAvailable = totalAvailable !== null && totalAvailable >= maxRequested;
  let text;
  if (resultCount > 0) {
    text = areMoreAvailable
      ? `Showing ${resultCount} of ${totalAvailable} properties`
      : `Showing ${resultCount} properties`;
  } else {
    text = "No results";
  }

  return (
    <div className={`tw-flex tw-flex-row tw-gap-4px tw-text-12px ${className}`}>
      <span>{text}</span>
      {areMoreAvailable && (
        <Tooltip
          className="tw-flex tw-self-center"
          trigger={<CircleInfoSolidV6 />}
          content={`Showing ${resultCount} of ${totalAvailable} most recent properties. Narrow your search or adjust your filters to see older properties.`}
          innerClassName="tw-max-w-[248px]"
          placement="top"
        />
      )}
    </div>
  );
};

export default ResultsCount;
